import {Component} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-entity-error-report',
  templateUrl: './entity-error-report.component.html',
  styleUrls: ['./entity-error-report.component.css']
})
export class EntityErrorReportComponent {
  constructor(public bsModalRef: BsModalRef) {
  }

  uploadRes: any;
  result: any
  message: any;

  ngOnInit() {
    this.result = this.uploadRes.result
    this.message = this.uploadRes.message
  }

  closeModal() {
    this.bsModalRef.hide();
  }
}
